<template>
  <div class="Notice">
    <div class="text">
      <slot />
    </div>
    <Icon
      v-if="isClosable"
      class="close"
      name="cross"
      @click="$emit('close')" />
  </div>
</template>

<script>
export default {
  props: {
    isClosable: Boolean,
  },
}
</script>

<style lang="scss">
.Notice {
  background: $neutral-lighter;
  border-radius: $radius-md;
  font-weight: $semibold;
  margin-bottom: 1rem;
  padding: 1rem;
  position: relative;
  text-align: center;

  > .close {
    cursor: pointer;
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  .Btn {
    margin-right: 0.25rem;
  }

  // ----------- Themes -------------
  &.danger {
    background: $danger-lighter;
    color: $danger;

    &.alt {
      border-left: 4px solid $danger;
    }
  }

  &.info {
    background: $info-lighter;
    color: $info;

    &.alt {
      border-left: 4px solid $info;
    }
  }

  // &.neutral {
  //   background: $neutral-lighter;
  //   color: $neutral;
  // }

  &.warning {
    background: $warning-lighter;
    color: $warning-dark;

    &.alt {
      border-left: 4px solid $warning;
    }
  }

  &.success {
    background: $success-lighter;
    color: $success-dark;

    &.alt {
      border-left: 4px solid $success;
    }
  }

  &.fancy {
    background: $fancy-lighter;
    color: $fancy;

    &.alt {
      border-left: 4px solid $fancy;
    }
  }

  &.alt {
    background: transparent;
    border-radius: 0;
    text-align: left;
  }
}
</style>
